import { Injectable } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { LoginFormComponentService } from '@spartacus/user/account/components';

@Injectable()
export class GonvarriLoginFormComponentService extends LoginFormComponentService {

  override form: UntypedFormGroup = new UntypedFormGroup({
    userId: new UntypedFormControl('', [
      Validators.required
    ]),
    password: new UntypedFormControl('', Validators.required),
  });

}
